import axios from "axios";
import Config from "config";
import { logger } from "helpers/logger";
import urlJoin from "helpers/urljoin";

export interface GeoData {
  sourceCountry: string | null;
  sourceCity: string | null;
}

export interface SearchSuggestionsResponse {
  personalized: boolean;
  data: Array<{
    id: number;
    country_full_name: string;
    country_short_name: string;
    country_alias: string;
    country_label: string;
    country_flag_image: string;
    booking_share_percentage: number;
    top_cities: {
      label: string;
      data: Array<{
        id: number;
        name: string;
        canonical_name: string;
        region_type: string;
        image: string | null;
        inventory_count?: number | null;
      }>;
    };
    top_universities: {
      label: string;
      data: Array<{
        id: number;
        name: string;
        canonical_name: string;
        region_type: string;
        image: string | null;
      }>;
    };
  }>;
}

export const getPersonalizedSearchSuggestions = async (geoData: GeoData) => {
  try {
    const url = urlJoin(Config.API_URL, "/api/v1/regions/search_suggestions");
    const res = await axios.get(url, {
      params: {
        source_country: geoData.sourceCountry,
        source_city: geoData.sourceCity,
      },
      timeout: 5000,
    });
    return res;
  } catch (error) {
    logger.error("Error fetching personalized search suggestions:", error);
    return "error";
  }
};
